import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

export function LaborCalendarModalShell({
  isOpen,
  onClose,
  title,
  icon: Icon,
  children,
  footer,
  size = 'md',
}) {
  if (!isOpen) return null;

  const maxWidthClass = size === 'lg' ? 'max-w-3xl' : 'max-w-lg';

  return createPortal(
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
    >
      <div
        className={`relative w-full ${maxWidthClass} max-h-[90vh] mx-4 bg-gray-800 rounded-2xl border border-gray-700 shadow-xl overflow-hidden flex flex-col`}
      >
        <div className="flex items-center justify-between p-5 border-b border-gray-700 shrink-0">
          <div className="flex items-center gap-3">
            {Icon && <Icon className="w-6 h-6 text-blue-400" />}
            <h2 className="text-xl font-semibold text-white">{title}</h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-gray-700 text-gray-400 hover:text-white"
            aria-label="Cerrar"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-5">{children}</div>
        {footer && (
          <div className="shrink-0 p-5 border-t border-gray-700 flex justify-end gap-3">{footer}</div>
        )}
      </div>
    </div>,
    document.body
  );
}
